import React, { useState, useEffect, useReducer } from "react";
import { Container, Nav, Modal, Form } from "react-bootstrap";
import { AiOutlineRight, AiFillCopy } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../common/storeContext'
import { TENANT_BUCKET, GLOBAL_BUCKET, GAME_MENU_DATA, IMAGE_SIZE_DYNAMIC } from '../../common/constants'
// import TransferBalanceDialog from '../../components/TransferBalanceDialog'
// import PromoDetailsDialog from '../../components/PromoDetailsDialog'
import Loading from '../../components/Loading';
import Alert from '../../components/Alert'
import ImageWithPlaceholder from '../../components/ImageWithPlaceholder'
import { useMiddletier } from "../../common/middletier";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from 'dayjs';
import PageTitle from '../pageTitle/template_01';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "swiper/css";
import "swiper/css/pagination";
import "./template_01.css";
import { format, parseISO } from 'date-fns';
import ShareQRDialog from '../../components/ShareQRDialog';
// const getAffiliateOverview = {
//   "total_member": "4",
//   "online_player": "0",
//   "link_click_count": "0",
//   "new_sign_up": "1",
//   "first_deposit_count": "1",
//   "active_member_count": 1,
//   "total_deposit": 113,
//   "total_withdraw": 0,
//   "commission_start_date": "2023-11-01",
//   "commission_end_date": "2023-11-30",
//   "released_commission": 12,
//   "company_win_loss": -54.16,
//   "turnover": 110.12,
//   "transaction": [
//     {
//       "game_provider_label": "Asia Gaming",
//       "bet_amount": 100.12,
//       "turnover": 100.12,
//       "win_loss": -49.16,
//       "active_members": 1
//     },
//     {
//       "game_provider_label": "Evo",
//       "bet_amount": 100.12,
//       "turnover": 100.12,
//       "win_loss": -49.16,
//       "active_members": 1
//     },
//     {
//       "game_provider_label": "Playtech",
//       "bet_amount": 100.12,
//       "turnover": 100.12,
//       "win_loss": -49.16,
//       "active_members": 1
//     },
//     {
//       "game_provider_label": "ebet",
//       "bet_amount": 100.12,
//       "turnover": 100.12,
//       "win_loss": -49.16,
//       "active_members": 1
//     },
//     {
//       "game_provider_label": "dreamgaming",
//       "bet_amount": 100.12,
//       "turnover": 100.12,
//       "win_loss": -49.16,
//       "active_members": 1
//     },
//   ]
// }



const OVERVIEW_ACTION = {
  SET_SELECTED_MONTH: 'SET_SELECTED_MONTH',
  SET_OVERVIEW_SUMMARY: 'SET_OVERVIEW_SUMMARY'
}

const initialOverivewData = {
  selectedMonth: new Date(),
  overviewSummary: {}
}

const overviewReducer = (state, action) => {
  switch (action.type) {

    case OVERVIEW_ACTION.SET_SELECTED_MONTH: {
      return { ...state, selectedMonth: action.payload };
    }

    case OVERVIEW_ACTION.SET_OVERVIEW_SUMMARY: {
      return { ...state, overviewSummary: action.payload };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

const Template_01 = (props) => {
  const { desktopTitleToggle, mobileTitleToggle } = props;
  const [startDate, setStartDate] = useState(new Date());
  const appState = useStoreState()
  const appDispatch = useStoreDispatch()
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [overviewState, overviewDispatch] = useReducer(overviewReducer, initialOverivewData)
  const [currentItem, setCurrentItem] = useState({})
  const [couponDetailDialogShow, setCouponDetailDialogShow] = useState(false)
  const [claimCouponDialogShow, setClaimCouponDialogShow] = useState(false)
  const [disabledSubmit, setDisabledSubmit] = useState(true);

  const { query, queries, mutation } = useMiddletier();
  const [showShareQR, setShowShareQR] = useState({show:false,url:'',url_title:''});


  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const { t, i18n } = useTranslation();


  const onChangeMonth = (month) => {
    overviewDispatch({ type: OVERVIEW_ACTION.SET_SELECTED_MONTH, payload: month })
  }

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, decimalPoint);
    const truncatedAmount = Math.floor(amount * factor) / factor;
    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: decimalPoint,
      maximumFractionDigits: decimalPoint,
    });
    return formattedAmount;
  }




  const onClickShare = (newValue) => {
    navigator.clipboard.writeText(newValue);
    appDispatch({
      type: APP_STORE_ACTION.SHOW_ALERT,
      payload: { description: `Copied ${newValue ?? '-'}`, typeAlert: 'success' }
    });
  };

  useEffect(() => {

    if (appState.loggedIn === false) {
      // setLoading(true)
      if (appState.loginWithToken === true) {
        setLoading(false)
        mutation([
          {
            index: 'loginWithTokenByAffiliate',
            method: 'loginWithTokenByAffiliate',
            params: [],
            attributes: []
          }
        ])
          .then(({ data }) => {
            // console.log('login token')
            setLoading(false)
            // console.log('data: ', data['loginWithTokenByAffiliate'])
            appDispatch({ type: APP_STORE_ACTION.LOGIN, payload: { ...data['loginWithTokenByAffiliate'] } })

          })
          .catch((error) => {
            // console.log('login error')
            setLoading(false)
            console.error(error)
            appDispatch({ type: APP_STORE_ACTION.SET_LOGIN_WITH_TOKEN, payload: false })
            if (error?.networkError?.statusCode === 401) {
              appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
            } else {
              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: error.message.toString(), typeAlert: 'error' }
              });
            }
          })
      } else {
        // console.log('login false')
        setLoading(false)
        appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
      }
    } else {
      // console.log('login true')
      setLoading(false)
    }
  }, [mutation, appDispatch, appState, navigate])


  useEffect(() => {
    setLoading(true)
    const formattedMonth = format(overviewState.selectedMonth, 'yyyy-MM');
    console.log('getMonth:', typeof formattedMonth)

    queries([{
      method: 'getAffiliateOverview',
      params: [
        { code: 'searchMonth', graphqlType: 'String', required: true, value: formattedMonth ?? '' },
      ],
      attributes: []
    }]).then(({ data }) => {
      setLoading(false)

      overviewDispatch({ type: OVERVIEW_ACTION.SET_OVERVIEW_SUMMARY, payload: data['getAffiliateOverview'] })


    }).catch((error) => {
      setLoading(false)

      console.log('error: ', error)
    })

  }, [queries, overviewState.selectedMonth])





  return (
    <>

      <div className={`overview_body ${isDesktopOrLaptop ? '' : `overview_body_m`} layout_body`}>
        <PageTitle desktopToggle={desktopTitleToggle} mobileToggle={mobileTitleToggle} title={'overview'} id={'overview_title'} />
        <Container className="overview_container">
          <div className="overview_wrap">

            {/* AFFILIATE INFORMATION */}
            <div className="overview_row overview_affiliate_information">
              <div className="overview_header">
                <div className="overview_title">{t('affiliate_information')}</div>
              </div>
              <div className="overview_content_body">
                <div className="overview_content_row">{t('affiliate_login')} : {appState?.user?.username}</div>
                <div className="overview_content_row">{t('affiliate_link')}</div>
                <div className="affiliateLink_row">
                  <div>
                    <div>- {t('member')}</div>
                    <div className="overview_affiliate_link">{`https://${appState?.domain}?affiliate=${appState?.user?.code}`}</div>
                  </div>
                  <div className="affiliate_shareButton">
                    <button className="font_button color_button btnShare" onClick={() => onClickShare(`https://${appState?.domain}?affiliate=${appState?.user?.code}`)} >{t('share')}</button>
                    <button className="font_button color_button btnShare" onClick={() => setShowShareQR({show:true,url:`https://${appState?.domain}?affiliate=${appState?.user?.code}`,url_title:`${(appState?.tenant??appState?.user?.tenant)?.toUpperCase()} Website URL`})} >{t('share_qr')}</button>
                  </div>
                </div>
                {/* <div className="affiliateLink_row">
                  <div>
                    <div>- {t('member_register_url')}</div>
                    <div className="overview_affiliate_link">{`https://${appState?.domain}/register?affiliate=${appState?.user?.code}`}</div>
                  </div>
                  <div className="affiliate_shareButton">
                    <button className="font_button color_button btnShare" onClick={() => onClickShare(`https://${appState?.domain}/register?affiliate=${appState?.user?.code}`)}>{t('share')}</button>
                    <button className="font_button color_button btnShare" onClick={() => setShowShareQR({show:true,url:`https://${appState?.domain}/register?affiliate=${appState?.user?.code}`,url_title:`${(appState?.tenant??appState?.user?.tenant)?.toUpperCase()} Website Register URL`})} >{t('share_qr')}</button>

                  </div>
                </div> */}
                {/* <div className="affiliateLink_row">
                  <div>
                    <div>- {t('sub_affiliate')}</div>
                    <div>https://imbaweb.com?affiliate=122223</div>
                  </div>
                  <div className="affiliate_shareButton">
                    <button className="font_button color_button btnShare" onClick={() => onClickShare('https://imbaweb.com?affiliate=122223')}>{t('share')}</button>
                  </div>
                </div> */}

              </div>
            </div>

            {/* OVERALL SUMMARY */}
            <div className="overview_row overview_overall_summary">
              <div className="overview_header">
                <div className="overview_title">{t('overall_summary')}</div>
                {/* <Form.Select aria-label="overallSummary" className="input_overallSummary">
                    <option>2023-10</option>
                    <option>2023-11</option>
                    <option>2023-12</option>
                  </Form.Select> */}
                <DatePicker
                  selected={overviewState.selectedMonth}
                  onChange={(month) => onChangeMonth(month)}
                  className="font_h5 input_endDate form-control"
                  placeholderText={'yyyy-MM'}
                  aria-label="month"
                  dateFormat="yyyy-MM"
                  showMonthYearPicker
                />

              </div>
              <div className="overview_content_body">
                <div className="overview_card_wrap">
                  <div className="overview_card_container">
                    <div className="overview_card_title">{t('summary')}</div>
                    <div className="overview_card_content">
                      <div className="overview_content_row">
                        <span>{t('total_member')}</span>
                        <span>{overviewState.overviewSummary?.total_member ?? 0}</span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('online_players')}</span>
                        <span>{overviewState.overviewSummary?.online_player ?? 0}</span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('no_of_clicks')}</span>
                        <span>{overviewState.overviewSummary?.link_click_count ?? 0}</span>
                      </div>
                    </div>
                  </div>
                  <div className="overview_card_container">
                    <div className="overview_card_title">{t('quick_summary')}</div>
                    <div className="overview_card_content">

                      <div className="overview_content_row">
                        <span>{t('new_sign_up')}</span>
                        <span>{overviewState.overviewSummary?.new_sign_up ?? 0}</span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('first_deposit')}</span>
                        <span>{overviewState.overviewSummary?.first_deposit_count ?? 0}</span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('active_member')}</span>
                        <span>{overviewState.overviewSummary?.active_member_count ?? 0}</span>
                      </div>
                    </div>
                  </div>
                  <div className="overview_card_container">
                    <div className="overview_card_title">{t('commission')}</div>
                    <div className="overview_card_content">
                      {overviewState.overviewSummary?.released_commission ?
                        <div className="overview_content_row">
                          <span>{overviewState.overviewSummary?.commission_start_date ?? '-'}<br />{overviewState.overviewSummary?.commission_end_date ?? '-'}</span>
                          <span>{formatAmount(overviewState.overviewSummary?.released_commission ?? 0, appState.currencyFormat.decimal_point)}</span>
                        </div> :
                        <div className="overview_content_row">
                          <span>{t('no_commission')}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* TRANSACTION DATE */}
            <div className="overview_row overview_transaction_date">
              <div className="overview_header">
                <div className="overview_title">{t('transaction_date')}</div>
              </div>
              <div className="overview_content_body">
                <div className="overview_card_wrap">
                  <div className="overview_card_container">
                    <div className="overview_card_title">{t('summary')}</div>
                    <div className="overview_card_content">
                      <div className="overview_content_row">
                        <span>{t('company_wl')}</span>
                        <span>{formatAmount(overviewState.overviewSummary?.company_win_loss ?? 0, appState.currencyFormat.decimal_point)} </span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('turnover')}</span>
                        <span>{formatAmount(overviewState.overviewSummary?.turnover ?? 0, appState.currencyFormat.decimal_point)}</span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('total_deposit')}</span>
                        <span>{formatAmount(overviewState.overviewSummary?.total_deposit ?? 0, appState.currencyFormat.decimal_point)}</span>
                      </div>
                      <div className="overview_content_row">
                        <span>{t('total_withdraw')}</span>
                        <span>{formatAmount(overviewState.overviewSummary?.total_withdraw ?? 0, appState.currencyFormat.decimal_point)}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* PROVIDER SUMMARY */}
            <div className="overview_row overview_provider_summary">
              <div className="overview_header">
                <div className="overview_title">{t('provider_summary')}</div>
              </div>
              <div className="overview_content_body">
                <div className={`overview_card_wrap ${(!overviewState.overviewSummary?.transaction || overviewState.overviewSummary?.transaction.length === 0) && ('p-0')}`}>
                  {overviewState.overviewSummary?.transaction?.length > 0 ? (
                    overviewState.overviewSummary?.transaction?.map(function (item, index) {
                      return (
                        <div className="overview_card_container">
                          <div className="overview_card_title">{t('current_month')} {item.game_provider_label}</div>
                          <div className="overview_card_content">
                            <div className="overview_content_row">
                              <span>{t('company_wl')}</span>
                              <span>{formatAmount(item.win_loss ?? 0, appState.currencyFormat.decimal_point)}</span>
                            </div>
                            <div className="overview_content_row">
                              <span>{t('total_active_member')}</span>
                              <span>{item.active_members ?? 0}</span>
                            </div>
                            <div className="overview_content_row">
                              <span>{t('number_of_bets')}</span>
                              <span>{item.bet_count ?? 0}</span>
                            </div>
                            <div className="overview_content_row">
                              <span>{t('turnover')}</span>
                              <span>{formatAmount(item.turnover ?? 0, appState.currencyFormat.decimal_point)}</span>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  ) : (<>{t('no_provider')}</>)
                  }

                </div>
              </div>
            </div>



          </div>
        </Container>
      </div>


      {isLoading && (<Loading />)}
      <ShareQRDialog show={showShareQR?.show} onHide={() => setShowShareQR({show:false,url:''})} shareURL={showShareQR?.url} avatarLogo={`${TENANT_BUCKET}/icon/wallet_user.png`} shareURLTitle={showShareQR?.url_title}/>
    </>
  );
}





export default Template_01;
